// Demo images for testing purposes
// These will be replaced with actual product images once available

export const demoProductImages = {
  // Sample athletic wear images from Unsplash (free to use)
  'cooling-performance-crew': {
    main: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop&crop=center',
    front: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop&crop=center',
    back: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=400&h=400&fit=crop&crop=center',
    detail: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&h=400&fit=crop&crop=center'
  },
  'classic-tshirt': {
    main: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop&crop=center',
    front: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop&crop=center',
    back: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=400&h=400&fit=crop&crop=center',
    'logo-detail': 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&h=400&fit=crop&crop=center'
  },
  'sport-tek-hoodie': {
    main: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop&crop=center',
    front: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=400&h=400&fit=crop&crop=center',
    embroidery: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&h=400&fit=crop&crop=center',
    texture: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop&crop=center'
  },
  'cooling-crop-top': {
    main: 'https://images.unsplash.com/photo-1544966503-7cc5ac882d5f?w=400&h=400&fit=crop&crop=center',
    front: 'https://images.unsplash.com/photo-1506629905521-b015b8d59d73?w=400&h=400&fit=crop&crop=center',
    back: 'https://images.unsplash.com/photo-1594736797933-d0851ba0b8e4?w=400&h=400&fit=crop&crop=center',
    action: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=400&fit=crop&crop=center'
  },
  'sport-bag': {
    main: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop&crop=center',
    open: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&h=400&fit=crop&crop=center',
    compartments: 'https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=400&h=400&fit=crop&crop=center',
    carrying: 'https://images.unsplash.com/photo-1590736969955-71cc94901144?w=400&h=400&fit=crop&crop=center'
  }
};

// Function to get demo image or fallback to placeholder
export const getDemoImage = (productSlug: string, imageType: string): string => {
  const productImages = demoProductImages[productSlug as keyof typeof demoProductImages];
  if (productImages && productImages[imageType as keyof typeof productImages]) {
    return productImages[imageType as keyof typeof productImages];
  }
  
  // Fallback to branded placeholder
  const productName = productSlug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  return `https://via.placeholder.com/400x400/10b981/ffffff?text=${encodeURIComponent(productName)}`;
}; 